import { c as _c } from "react/compiler-runtime";
import { FormSelectDataType, getContactFieldTitle, useTranslation as useUiTranslation } from '@systemeio/ui';
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const useSmsSubstitutes = () => {
  const $ = _c(20);
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    fields: substitutes
  } = useContactFields();
  let t0;
  if ($[0] !== substitutes?.items || $[1] !== t || $[2] !== tUi) {
    let t1;
    if ($[4] !== tUi) {
      t1 = el => ({
        id: `{{${el.slug}}}`,
        caption: getContactFieldTitle(el, tUi)
      });
      $[4] = tUi;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    const contactSubstitutionData = (substitutes?.items ?? []).map(t1);
    let t2;
    if ($[6] !== t) {
      t2 = t("dashboard.email.contact_affiliate_id");
      $[6] = t;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== t2) {
      t3 = {
        caption: t2,
        id: "{{affiliate_id}}"
      };
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== t) {
      t4 = t("dashboard.email.contact_affiliate_url");
      $[10] = t;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== t4) {
      t5 = {
        caption: t4,
        id: "{{affiliate_dashboard}}"
      };
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== t3 || $[15] !== t5) {
      t6 = [t3, t5];
      $[14] = t3;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    const affiliateSubstitutionData = t6;
    t0 = [...contactSubstitutionData, ...affiliateSubstitutionData];
    $[0] = substitutes?.items;
    $[1] = t;
    $[2] = tUi;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const substitutionData = t0;
  const isReady = !!substitutes;
  let t1;
  if ($[17] !== isReady || $[18] !== substitutionData) {
    t1 = {
      substitutionData,
      isReady
    };
    $[17] = isReady;
    $[18] = substitutionData;
    $[19] = t1;
  } else {
    t1 = $[19];
  }
  return t1;
};